export const waitToBeOnline = async (): Promise<void> => {
  // Return a promise that only resolves when the browser is online
  return new Promise((resolve) => {
    if (navigator.onLine) {
      resolve();
    } else {
      const intervalId = setInterval(() => {
        if (navigator.onLine) {
          clearInterval(intervalId);
          resolve();
        }
      }, 250);
    }
  });
};
